import { Link, useLocation } from "react-router-dom";
import useSeo from "@/hooks/useSeo";

export default function NotFound() {
  const location = useLocation();
  useSeo({
    title: "页面未找到 - NBA直播吧",
    description: "抱歉，您访问的页面未找到。请返回NBA直播吧首页，继续观看NBA直播、查询赛程与赛事新闻。",
  });

  return (
    <div className="relative w-full min-h-[70vh] flex items-center justify-center px-4 py-16 overflow-hidden">
      <span className="absolute text-[10rem] md:text-[18rem] font-heading font-bold text-primary-50 select-none pointer-events-none">
        404
      </span>
      <div className="relative z-10 flex flex-col items-center text-center max-w-md">
        <span className="w-16 h-16 rounded-full bg-accent-100 text-accent-600 flex items-center justify-center text-3xl mb-5">
          <i className="ri-basketball-line"></i>
        </span>
        <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">页面未找到</h1>
        <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
          抱歉，您访问的页面不存在或已被移除。返回首页继续观看NBA直播、查询赛程与赛事新闻吧。
        </p>
        <p className="mt-2 text-xs text-foreground-400 font-label break-all">{location.pathname}</p>
        <div className="mt-7 flex flex-wrap justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-home-line"></i> 返回首页
          </Link>
          <Link
            to="/live"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-background-100 text-foreground-900 border border-background-300 text-sm font-semibold hover:bg-background-200 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-live-line"></i> 观看直播
          </Link>
        </div>
      </div>
    </div>
  );
}